// const config = {
//   API_BASE: import.meta.env.VITE_API_BASE || 'http://localhost:9000',
//   GOOGLE_CLIENT_ID:'309513215166-6pd90lo3suhdlgdbqnm61lsi5l6utmse.apps.googleusercontent.com',
//   PAYPAL_ID:"AchOHw55z7ucP4201sgr5W51_fsRSBObyTqFqNN3UHjuYuNv0CtkO37SEXeRK5YoPHu_iUJa24EfYYXr"
// };

 
// For local testing: run with VITE_API_BASE=http://localhost:9000 npm run dev
// so Google signup and form submission hit your local backend (and your sheet).
const config = {
  API_BASE: 'https://try.latentforce.ai',
  GOOGLE_CLIENT_ID: '198898211708-51m2h5dd7f5t2uqciqef6e04lsf8tkio.apps.googleusercontent.com',
  PAYPAL_ID: "AchOHw55z7ucP4201sgr5W51_fsRSBObyTqFqNN3UHjuYuNv0CtkO37SEXeRK5YoPHu_iUJa24EfYYXr"
};



// const config = {
//   API_BASE: 'https://www.extractors.ai',
//   GOOGLE_CLIENT_ID:'309513215166-6pd90lo3suhdlgdbqnm61lsi5l6utmse.apps.googleusercontent.com',
//   PAYPAL_ID:"AchOHw55z7ucP4201sgr5W51_fsRSBObyTqFqNN3UHjuYuNv0CtkO37SEXeRK5YoPHu_iUJa24EfYYXr"
// };




// const config = {
//   API_BASE: 'https://test-dev.extractors.ai',
//   GOOGLE_CLIENT_ID:'309513215166-6pd90lo3suhdlgdbqnm61lsi5l6utmse.apps.googleusercontent.com',
//   PAYPAL_ID:"AchOHw55z7ucP4201sgr5W51_fsRSBObyTqFqNN3UHjuYuNv0CtkO37SEXeRK5YoPHu_iUJa24EfYYXr"
// };



// const config = {
//   API_BASE_URL: 'https://agents.latentforce.ai',
// };

// console.log('API Base URL:', config.API_BASE_URL);

export default config;

// // For runing localhost
// REACT_APP_LF_FRONTEND_ENV_TYPE=http://localhost:5000 npm start

// // For runing production
// REACT_APP_LF_FRONTEND_ENV_TYPE=https://app.latentforce.ai/ npm run build
